import {
  PartnerBusinessTypeSchema,
  type PartnerBusinessType as GeneratedPartnerBusinessType
} from '~/services/api/generated'

// Mirrors backend App\Enums\PartnerBusinessType

export type PartnerBusinessType = GeneratedPartnerBusinessType

export const PartnerBusinessType = {
  RESTAURANT: PartnerBusinessTypeSchema.enum.restaurant,
  CATERER: PartnerBusinessTypeSchema.enum.caterer,
  BAKERY: PartnerBusinessTypeSchema.enum.bakery,
  CAFE_COFFEE_SHOP: PartnerBusinessTypeSchema.enum.cafe_coffee_shop,
  FOOD_TRUCK_MOBILE_VENDOR: PartnerBusinessTypeSchema.enum.food_truck_mobile_vendor,
  GHOST_KITCHEN_VIRTUAL_KITCHEN: PartnerBusinessTypeSchema.enum.ghost_kitchen_virtual_kitchen,
  GROCERY_SPECIALTY_FOOD: PartnerBusinessTypeSchema.enum.grocery_specialty_food,
  GROCERY: PartnerBusinessTypeSchema.enum.grocery,
  RESTAURANT_GROUP: PartnerBusinessTypeSchema.enum.restaurant_group,
  FRANCHISEE: PartnerBusinessTypeSchema.enum.franchisee,
  FRANCHISOR_HQ: PartnerBusinessTypeSchema.enum.franchisor_hq,
  CORPORATE_ENTERPRISE_FOOD_PROVIDER:
    PartnerBusinessTypeSchema.enum.corporate_enterprise_food_provider,
  ENTERPRISE: PartnerBusinessTypeSchema.enum.enterprise,
  SMALL_BUSINESS: PartnerBusinessTypeSchema.enum.small_business,
  OTHER: PartnerBusinessTypeSchema.enum.other
} satisfies Record<string, GeneratedPartnerBusinessType>

export const PartnerBusinessTypeValues: readonly GeneratedPartnerBusinessType[] = [
  PartnerBusinessTypeSchema.enum.restaurant,
  PartnerBusinessTypeSchema.enum.caterer,
  PartnerBusinessTypeSchema.enum.bakery,
  PartnerBusinessTypeSchema.enum.cafe_coffee_shop,
  PartnerBusinessTypeSchema.enum.food_truck_mobile_vendor,
  PartnerBusinessTypeSchema.enum.ghost_kitchen_virtual_kitchen,
  PartnerBusinessTypeSchema.enum.grocery_specialty_food,
  PartnerBusinessTypeSchema.enum.grocery,
  PartnerBusinessTypeSchema.enum.restaurant_group,
  PartnerBusinessTypeSchema.enum.franchisee,
  PartnerBusinessTypeSchema.enum.franchisor_hq,
  PartnerBusinessTypeSchema.enum.corporate_enterprise_food_provider,
  PartnerBusinessTypeSchema.enum.enterprise,
  PartnerBusinessTypeSchema.enum.small_business,
  PartnerBusinessTypeSchema.enum.other
]
